import { render, staticRenderFns } from "./simpleTextLayerDrawerA.vue?vue&type=template&id=44082b7a&"
import script from "./simpleTextLayerDrawerA.vue?vue&type=script&lang=ts&"
export * from "./simpleTextLayerDrawerA.vue?vue&type=script&lang=ts&"
import style0 from "./simpleTextLayerDrawerA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports